import React from "react";
import WarningPanelv2 from "../../lib/warning_panel/warning_panel_v2";
import { ProductExchangeHelpDocURL } from "../../../constants/campaigns";
import ExternalLink from "../../lib/external_link";

const NewPodcasterBar = ({ onClick }) => {
  return (
    <WarningPanelv2>
      <h3>New Podcast Accepts</h3>
      <p>
        Hooray! New podcasts have accepted your campaign invitation. Be sure to{" "}
        <button className="fake-link" onClick={onClick}>
          Download Podcast Info
        </button>{" "}
        for the updated list of important show information for your campaign.{" "}
        <ExternalLink href={ProductExchangeHelpDocURL}>Learn More ></ExternalLink>
      </p>
    </WarningPanelv2>
  );
};

export default NewPodcasterBar;
